// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__h04vV","s":"avatar_s__-6uSQ","l":"avatar_l__DDziJ"};